import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LangProvider } from "@/i18n/LangProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import BetaBanner from "@/components/BetaBanner";

import Home from "@/pages/Home";
import Reservar from "@/pages/Reservar";
import ReservaConfirmada from "@/pages/ReservaConfirmada";
import ReservaStatus from "@/pages/ReservaStatus";
import Contacto from "@/pages/Contacto";
import Servicos from "@/pages/Servicos";
import Termos from "@/pages/Termos";
import Direitos from "@/pages/Direitos";
import Tarifario from "@/pages/Tarifario";
import Admin from "@/pages/Admin";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return <>{children}</>;
  return (
    <>
      <div className="fixed top-0 left-0 right-0 z-50">
        <BetaBanner />
        <Header />
      </div>
      <main>{children}</main>
      <Footer />
      <FloatingWhatsApp />
    </>
  );
};

const AppShell = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/servicos" element={<Servicos />} />
      <Route path="/reservar" element={<Reservar />} />
      <Route path="/reserva/confirmada" element={<ReservaConfirmada />} />
      <Route path="/reserva/status/:id" element={<ReservaStatus />} />
      <Route path="/contacto" element={<Contacto />} />
      <Route path="/tarifario" element={<Tarifario />} />
      <Route path="/termos-e-condicoes" element={<Termos />} />
      <Route path="/direitos-de-autor" element={<Direitos />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <AppShell />
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141414",
                color: "#e8e4da",
                border: "1px solid #2a2a2a",
                borderRadius: 0,
                fontFamily: "Manrope, system-ui, sans-serif",
                letterSpacing: "0.05em",
              },
            }}
          />
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
